export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, Показатели показатели пациента ', trigger: 'blur' },
    ],
};
